module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style6/menu-style6.component.html
// module id = ./src/app/mega-menu/menu-style6/menu-style6.component.html
// module chunks = main